import { NegotiationFieldMeta, NestedLegItem } from 'api'
import { ReadAccess } from 'utils'
import { TypedEditableCallbackParams } from 'view/components/datagrid'

export const NOTE_INDEXES = ['0', '1', '2', '3', '4']

/* Pre Trade Assignments */

type PreTradeAssignmentNegotiatiableFields =
  | NegotiationFieldMeta.ACCRUED_INTEREST
  | NegotiationFieldMeta.FUND_ID
  | NegotiationFieldMeta.INITIATOR_BOOK
  | NegotiationFieldMeta.INITIATOR_STRATEGY
  | NegotiationFieldMeta.NOTIONAL
  | NegotiationFieldMeta.START_CONSIDERATION
  | NegotiationFieldMeta.START_CONSIDERATION_OVERRIDE

export function makeCanEditPreTradeAssignmentDetailField(field: PreTradeAssignmentNegotiatiableFields) {
  return function canEditPreTradeAssignmentDetailField(params: TypedEditableCallbackParams<NestedLegItem>) {
    const fieldType = params.data?.negotiationFields[field]?.fieldType

    return fieldType === ReadAccess.READ_WRITE || fieldType === ReadAccess.INITIATOR_WRITE_RESPONDER_READ
  }
}
